/**
 * Tab Component
 *
 * @file tab.js
 */
import $ from "jquery";

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  

  const defaultTab = () => {
    $(".gallert-tab a").on("click", function(){
      var tHref = $(this).attr("href");
      $(".gallert-tab a").removeClass("active");
      $(this).addClass("active");
      $(".gallery-tab-body .gallery-content").removeClass("active");
      $(tHref).addClass("active");
      return false;
    });
  };

  const defaultAnchor = () => {
    
  };

  const init = () => {
    defaultTab();
    defaultAnchor();
  };

  return {
    init,
  };
})();

export default tabs;
